import React, { useState } from "react"
import { X } from "lucide-react"
import "./GenerateLetterModal.css"

const GenerateLetterModal = ({ onClose, onGenerate }) => {
  const [selectedType, setSelectedType] = useState("Patient")

  return (
    <div className="modal-overlay">
      <div className="modal-container">
        <div className="modal-header">
          <h2>Generate Letter</h2>
          <button className="close-button" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        <div className="modal-content">
          <p className="select-text">
            Select letter<span className="required">*</span>
          </p>

          <div className="letter-options">
            <label
              className={`letter-option ${selectedType === "Patient" ? "selected" : ""}`}
              onClick={() => setSelectedType("Patient")}
            >
              <div className="radio-container">
                <input
                  type="radio"
                  name="letterType"
                  value="patient"
                  checked={selectedType === "Patient"}
                  onChange={() => setSelectedType("Patient")}
                />
                <div className="radio-circle"></div>
              </div>
              <div className="option-content">
                <h3>Patient letter</h3>
                <p>Patient letter will contain general terms</p>
              </div>
            </label>

            <label
              className={`letter-option ${selectedType === "Doctor" ? "selected" : ""}`}
              onClick={() => setSelectedType("Doctor")}
            >
              <div className="radio-container">
                <input
                  type="radio"
                  name="letterType"
                  value="doctor"
                  checked={selectedType === "Doctor"}
                  onChange={() => setSelectedType("Doctor")}
                />
                <div className="radio-circle"></div>
              </div>
              <div className="option-content">
                <h3>Doctor letter</h3>
                <p>Doctor letter will contain medical terms</p>
              </div>
            </label>
          </div>
        </div>

        <div className="modal-footer">
          <button className="cancel-button" onClick={onClose}>
            Cancel
          </button>
          <button className="generate-button" onClick={() => onGenerate(selectedType)}>
            Generate letter
          </button>
        </div>
      </div>
    </div>
  )
}

export default GenerateLetterModal

